import boxesImage from '@/assets/landing/comparison/boxes.webp'
import checkBrand from '@/assets/landing/comparison/check-brand.svg'
import checkGray from '@/assets/landing/comparison/check-gray.svg'

import {
  ComparisonBody,
  ComparisonContainer,
  ComparisonHeading,
  ComparisonImage,
  QnaCheckIcon,
  QnaItem,
  QnaList,
  QnaText,
} from './styles'

const QNA_ITEMS = [
  { text: '1박스 안에 밀봉봉투가 총 9장 들어있습니다', highlighted: true },
  { text: '최소 주문 가능 수량 : 1박스 (총 9장)', highlighted: false },
  { text: '최대 주문 가능 수량 : 3박스 (총 27장)', highlighted: false },
]

export function ComparisonQnaSection() {
  return (
    <ComparisonContainer>
      <ComparisonHeading>밀봉비닐 구성안내</ComparisonHeading>
      <ComparisonBody>
        <ComparisonImage
          src={boxesImage}
          alt='박스 1개에 밀봉비닐 9장 구성'
          width={262}
          height={120}
          loading='lazy'
          decoding='async'
        />
        <QnaList>
          {QNA_ITEMS.map((item) => (
            <QnaItem key={item.text}>
              <QnaCheckIcon
                src={item.highlighted ? checkBrand : checkGray}
                alt=''
              />
              <QnaText highlighted={item.highlighted}>{item.text}</QnaText>
            </QnaItem>
          ))}
        </QnaList>
      </ComparisonBody>
    </ComparisonContainer>
  )
}
